import { Injectable } from '@angular/core';
import { RoutePlannerSummaryData } from '../../models/route-model';
import { SummaryData } from '../../models/route-summary-model';
import { RoutePlannerService } from '../route-planner/route-planner.service';

@Injectable({
  providedIn: 'root'
})
export class RoutePlannerSummaryService {

  private routeSummaryData: RoutePlannerSummaryData;

  constructor( private routePlannerService: RoutePlannerService) {
    this.routeSummaryData = this.routePlannerService.routeDataModel.SummaryData;
  }

  public parseRouteSummaryData(routeSummaryData: any): void {

    const summaryList: Array<SummaryData> = [];

    routeSummaryData.forEach((routeItem: any) => {
      const summaryData = new SummaryData(routeItem.summary, this.routeSummaryData.DistanceType);
      summaryData.legs = routeItem.legs;
      summaryData.overviewPolyline = routeItem.overview_polyline;

      routeItem.legs.forEach( leg => {
        summaryData.Duration.push( leg.duration_in_traffic || leg.duration );
        summaryData.Distance.push( leg.distance );
      });
      summaryList.push( summaryData );
    });

    this.summaryDataList = summaryList;
  }

  get summaryDataList() {
    return this.routeSummaryData.SummaryDataList;
  }

  set summaryDataList(list) {
    this.routeSummaryData.SummaryDataList = list;
  }

}

